import Layout from '../../../brands/components/Layout'
import { useNavigate } from 'react-router-dom'
import Details from './details'

const ApplyTimeoffrequest: React.FC = () => {
    const navigate = useNavigate()
    return (
        <Layout>
            <div className="row mb-3">
                <div className="col-sm-6">
                    <h4>Time-Off Requests</h4>
                </div>
                <div className="col-sm-6">
                    <div className="custom-btn-design">
                        <a
                            onClick={() => {
                                navigate('/time-off/apply')
                            }}
                            className="button button-primary button-align-right"
                        >
                            APPLY FOR TIME OFF
                        </a>
                    </div>
                </div>
            </div>
            <Details />
        </Layout>
    )
}

export default ApplyTimeoffrequest
